import {
  FETCH_CONTACT_BLACKLIST_REQUEST,
  FETCH_CONTACT_BLACKLIST_SUCCESS,
  FETCH_CONTACT_BLACKLIST_FAILURE,
  ADD_BLACKLIST_ENTRY_REQUEST,
  ADD_BLACKLIST_ENTRY_SUCCESS,
  ADD_BLACKLIST_ENTRY_FAILURE,
  UPDATE_BLACKLIST_ENTRY_REQUEST,
  UPDATE_BLACKLIST_ENTRY_SUCCESS,
  UPDATE_BLACKLIST_ENTRY_FAILURE,
  DELETE_BLACKLIST_ENTRY_REQUEST,
  DELETE_BLACKLIST_ENTRY_SUCCESS,
  DELETE_BLACKLIST_ENTRY_FAILURE,
  FETCH_AVAILABLE_CONTACTS_REQUEST,
  FETCH_AVAILABLE_CONTACTS_SUCCESS,
  FETCH_AVAILABLE_CONTACTS_FAILURE,
  SET_BLACKLIST_FILTERS,
  CLEAR_BLACKLIST_ERROR,
  RESET_BLACKLIST_STATE
} from './types';

import contactBlacklistService from 'services/contactBlacklist.service';

export const fetchBlacklistEntries = (filters = {}, page = 1, pageSize = 25) => async (dispatch) => {
  dispatch({ type: FETCH_CONTACT_BLACKLIST_REQUEST });
  
  try {
    const data = await contactBlacklistService.getBlacklistEntries(filters, page, pageSize);
    dispatch({
      type: FETCH_CONTACT_BLACKLIST_SUCCESS,
      payload: data
    });
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_CONTACT_BLACKLIST_FAILURE,
      payload: error.message || 'Failed to fetch blacklist entries'
    });
    throw error;
  }
};

export const addBlacklistEntry = (entryData) => async (dispatch) => {
  dispatch({ type: ADD_BLACKLIST_ENTRY_REQUEST });
  
  try {
    const data = await contactBlacklistService.addBlacklistEntry(entryData);
    dispatch({
      type: ADD_BLACKLIST_ENTRY_SUCCESS,
      payload: data
    });
    return data;
  } catch (error) {
    dispatch({
      type: ADD_BLACKLIST_ENTRY_FAILURE,
      payload: error.message || 'Failed to add blacklist entry'
    });
    throw error;
  }
};

export const updateBlacklistEntry = (id, updateData) => async (dispatch) => {
  dispatch({ type: UPDATE_BLACKLIST_ENTRY_REQUEST });
  
  try {
    const data = await contactBlacklistService.updateBlacklistEntry(id, updateData);
    dispatch({
      type: UPDATE_BLACKLIST_ENTRY_SUCCESS,
      payload: data
    });
    return data;
  } catch (error) {
    dispatch({
      type: UPDATE_BLACKLIST_ENTRY_FAILURE,
      payload: error.message || 'Failed to update blacklist entry'
    });
    throw error;
  }
};

export const deleteBlacklistEntry = (id) => async (dispatch) => {
  dispatch({ type: DELETE_BLACKLIST_ENTRY_REQUEST });
  
  try {
    await contactBlacklistService.deleteBlacklistEntry(id);
    dispatch({
      type: DELETE_BLACKLIST_ENTRY_SUCCESS,
      payload: id
    });
  } catch (error) {
    dispatch({
      type: DELETE_BLACKLIST_ENTRY_FAILURE,
      payload: error.message || 'Failed to delete blacklist entry'
    });
    throw error;
  }
};

export const fetchAvailableContacts = (searchQuery = '', page = 1, pageSize = 20) => async (dispatch) => {
  dispatch({ type: FETCH_AVAILABLE_CONTACTS_REQUEST });
  
  try {
    const data = await contactBlacklistService.getAvailableContacts(searchQuery, page, pageSize);
    dispatch({
      type: FETCH_AVAILABLE_CONTACTS_SUCCESS,
      payload: data
    });
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_AVAILABLE_CONTACTS_FAILURE,
      payload: error.message || 'Failed to fetch available contacts'
    });
    throw error;
  }
};

export const setBlacklistFilters = (filters) => ({
  type: SET_BLACKLIST_FILTERS,
  payload: filters
});

export const clearBlacklistError = () => ({
  type: CLEAR_BLACKLIST_ERROR
});

export const resetBlacklistState = () => ({
  type: RESET_BLACKLIST_STATE
});